import { styled, makeStyles } from '@material-ui/core/styles';
import { Box, Grid } from '@material-ui/core';

export const Sidebar = styled(Box)({
  width: '200px',
  height: '100%',
  position: 'fixed',
  top: '60px',
  left: 0,
  display: 'flex',
  flexDirection: 'column',
  padding: '20px 0',
  zIndex: 10,
});

export const SafeArea = styled(Grid)({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  padding: '75px 20px 20px 220px',
  minHeight: '100vh',
  '@media (max-width:850px)': {
    paddingLeft: '20px',
    paddingTop: '130px',
  },
});

export const useStyles = makeStyles(theme => ({
  sidebar: {
    background: theme.colors.backgroundLight,
  },
  navLink: {
    display: 'flex',
    alignItems: 'center',
    padding: '12px 20px',
    color: '#ffffffcc',
    textDecoration: 'none',
    fontSize: '14px',
    transition: 'background 0.2s',
    '&:hover': {
      background: '#ffffff11',
    },
    '& svg': {
      marginRight: '12px',
      fontSize: '20px',
    },
  },
  activeLink: {
    color: theme.colors.primary,
    background: '#ffffff11',
  },
}));
